module.exports = __webpack_public_path__ + "static/amelie.4413aa74.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/about/amelie.png
// module id = 567
// module chunks = 263791100135453